import { createContext } from "react";

import { ClientInbox } from "../types/client-inbox";

/** The chart client's threads, provided by the client chart tabs while the Messages tab is on. */
export const ClientInboxContext = createContext<ClientInbox | undefined>(undefined);
